import { resetUserLocalStorage } from '@utils/localStorage'
import { useCallback } from 'react'
import { nhost } from 'src/nhost'
import { signOutSession } from '../signOutSession'

export default function useUserSignOut() {
  return useCallback(() => {
    signOutSession(nhost)
    resetUserLocalStorage()
  }, [])
}
